import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth.jsx';
import { doitPasserParAccueil, CHEMIN_ACCUEIL } from '../lib/onboarding.js';

/**
 * Réserve un écran aux utilisateurs connectés.
 *
 * Ce n'est qu'un confort d'affichage : les droits sont vérifiés par le
 * serveur, qui refuse toute requête sans session valide. Masquer un écran ne
 * protège rien par soi-même.
 */
export function RequireAuth({ children }) {
  const { user, chargement } = useAuth();
  const emplacement = useLocation();

  // Tant que /auth/me n'a pas répondu, on ne sait pas : rediriger tout de
  // suite renverrait un utilisateur déjà connecté vers la page de connexion à
  // chaque rechargement.
  if (chargement) {
    return (
      <main className="page">
        <p role="status">Chargement…</p>
      </main>
    );
  }

  if (!user) {
    // `state` permet de revenir ici après la connexion.
    return <Navigate to="/connexion" state={{ depuis: emplacement.pathname }} replace />;
  }

  // Première connexion : on passe d'abord par l'écran d'accueil. Le détour est
  // décidé ici plutôt qu'à la fin de l'inscription, car le retour de Google est
  // une redirection choisie par le serveur — un seul test couvre donc les deux
  // chemins d'entrée.
  if (doitPasserParAccueil(user, emplacement.pathname)) {
    return <Navigate to={CHEMIN_ACCUEIL} replace />;
  }

  return children;
}
